// GLOBAL CACHE
let cachedPages: Record<number, any[]> = {};
let cachedSelectedName: string = "";
let hasInitializedGlobal = false;

import { useEffect, useState, useRef } from "react";
import { getPriorityCompaniesApi } from "../../services/company/companyService";
import { setTenant, getTenant } from "../../utils/tenantManager";
import { getDecodedToken } from "../../utils/authToken";

const CompanySwitcher = () => {
  const [companies, setCompanies] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedName, setSelectedName] = useState<string>(
    cachedSelectedName || "Company"
  );

  const decoded = getDecodedToken();

  const currentTenant =
    getTenant() || decoded?.tenant_id || null;

  const isFirstRender = useRef(true);

  const loadCompanies = async (pageNumber: number) => {
    // if page already cached → use it
    if (cachedPages[pageNumber]) {
      setCompanies(cachedPages[pageNumber]);
      return;
    }

    try {
      const res = await getPriorityCompaniesApi(
        currentTenant,
        pageNumber,
        10
      );

      const list = res?.data || [];

      cachedPages[pageNumber] = list;
      setCompanies(list);

      // run only once globally
      if (!hasInitializedGlobal && list.length > 0) {
        const selected = list[0];

        cachedSelectedName = selected.name;
        setSelectedName(selected.name);

        if (!getTenant()) {
          setTenant(selected.id);
        }

        hasInitializedGlobal = true;
      }
    } catch (err) {
      console.error("Company load error", err);
    }
  };

  useEffect(() => {
    // prevent strict mode double call
    if (isFirstRender.current) {
      isFirstRender.current = false;
      loadCompanies(page);
      return;
    }

    loadCompanies(page);
  }, [page]);

  const selectCompany = (company: any) => {
    setTenant(company.id);

    cachedSelectedName = company.name;
    setSelectedName(company.name);

    setOpen(false);

    window.location.reload();
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="border px-3 py-1 rounded min-w-[160px] text-left"
      >
        {selectedName} ▾
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-64 bg-white shadow rounded z-50">
          <div className="max-h-60 overflow-y-auto">
            {companies.map((c, index) => (
              <div
                key={c.id}
                onClick={() => selectCompany(c)}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                  index === 0 ? "bg-blue-100 font-semibold" : ""
                }`}
              >
                {c.name}
              </div>
            ))}
          </div>

          <div className="flex justify-between p-2 text-sm border-t">
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              className="disabled:opacity-50"
            >
              Prev
            </button>

            <span>Page {page}</span>

            <button onClick={() => setPage((p) => p + 1)}>
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanySwitcher;